import React from 'react';
import styled from 'styled-components';

export const PageLayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  min-width: calc(1080px - 68px);
`;

type PageLayoutProps = {
  style?: React.CSSProperties;
};

const PageLayout = ({ children, style = {} }: React.PropsWithChildren<PageLayoutProps>) => {
  return <PageLayoutContainer style={style}>{children}</PageLayoutContainer>;
};

export default PageLayout;
